export interface HomebrewItem {
  icon: string;
  title: string;
  desc: string;
}

export const homebrewItems: ReadonlyArray<HomebrewItem> = [
  {
    icon: '🐉',
    title: 'Creature Forge',
    desc: 'Design original creatures with custom stats, abilities, and behaviours. Drop them into your own quests or share them with the community.',
  },
  {
    icon: '⚗',
    title: 'Item Workshop',
    desc: 'Craft unique weapons, armor, potions, and artifacts — complete with lore, stat bonuses, and rarity tiers.',
  },
  {
    icon: '✨',
    title: 'Spells & Skills',
    desc: 'Author new spells and skills with custom effects, costs, and progression paths that plug directly into the BRP rules engine.',
  },
  {
    icon: '🏪',
    title: 'Community Marketplace',
    desc: 'Publish your creations to the marketplace. GMs and players can discover, rate, and use your homebrew content in their adventures.',
  },
  {
    icon: '💰',
    title: 'Monetize Your Creations',
    desc: 'Set your own price for premium homebrew content. Earn revenue every time another creator or player uses your work.',
  },
];
